import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Widget from "@components/Widget/Widget";
import { Delay } from "@enums";
import "./RadarWidget.scss"; // Ensure to include your CSS file
import { useIataContext } from "@contexts/IataContext";
const iataToAreaMap = {
    OSL: "xband",
    BGO: "sorvestnorge",
    TRD: "trlagnordland",
    SVG: "sorvestnorge",
};
export const RadarWidget = () => {
    const [key, setKey] = useState(0);
    const { iata } = useIataContext();
    useEffect(() => {
        const intervalId = setInterval(() => {
            setKey((prevKey) => prevKey + 1); // Increment key to force re-render
        }, Delay.FiveMinutes);
        return () => clearInterval(intervalId); // Cleanup interval on component unmount
    }, []);
    return (_jsx(Widget.Container, { children: _jsx(Widget.Body, { children: _jsx("div", { className: "radar-widget-wrapper", children: _jsx("div", { className: "radar-widget", children: _jsx("img", { src: `https://radarapi.met.no/api/get/${iataToAreaMap[iata]}/lx-reflectivity/animation`, alt: "Radar image showing reflectivity in the past hour", className: "radar-widget-image" }, key) }) }) }) }));
};
RadarWidget.displayName = "RadarWidget";
